import React from 'react';
import { ProtectedPage } from '../../layout/ProtectedPage';
import PenerimaTindakLanjut from '../../componen/penerima/PenerimaTindakLanjut';

export const PenerimaTindakLanjutPages = () => <ProtectedPage><PenerimaTindakLanjut /></ProtectedPage>;

export default PenerimaTindakLanjutPages;
